module.exports = __webpack_public_path__ + "img/bullet-orange.330698c9.svg";